export default "__VITE_ASSET__xlil7Ku6__"